/**
 * Следы: список и отладочная запись пакета (§Т2.3).
 */

import { apiFetch } from "./client.js";

export type TraceView = {
  readonly id: number;
  readonly hexId: string;
  readonly quality: string;
  readonly expiresAt: string;
};

export type TraceBatchResult = {
  readonly traces: readonly TraceView[];
};

export async function fetchTraces(
  token: string,
  signal?: AbortSignal,
): Promise<{ traces: readonly TraceView[] }> {
  return apiFetch<{ traces: readonly TraceView[] }>("/traces", {
    token,
    ...(signal ? { signal } : {}),
  });
}

export async function submitTraceBatch(
  points: ReadonlyArray<{
    lat: number;
    lng: number;
    accuracy: number;
    recordedAt: string;
  }>,
  token: string,
  idempotencyKey: string,
): Promise<TraceBatchResult> {
  return apiFetch<TraceBatchResult>("/traces/batch", {
    method: "POST",
    token,
    headers: { "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({ points }),
  });
}
